<template>
	 <div id="parseTips" ref="parseTips" v-show="parseTipsShow" v-cloak class="torrent-parse">
		<i v-loading='true'  class="torrent-parse-loadding"></i>
	    <div ref="parseText" class="torrent-parse-text">{{$t('language.remoteTask.parseMagnetRunning')}}</div>
		<div class="title">
			<div class="icon white-close dialog-close" @click="close()"></div>
		</div>
	</div>
	
</template>


<script>
	export default {
		data: function() {
			return {
				parseTipsShow: false,
				}
			},
			mounted(){
				this.adapterWidth();
			},
			methods:{
				// 根据不同语言调整显示宽度大小
				adapterWidth(){
					let text = this.$refs.parseText.innerText;
					let widthLen = text.length;
					if(this.$i18n.locale=='chinese' || this.$i18n.locale=='traditionalChinese'){
						widthLen = 21 * widthLen;
					}else if(this.$i18n.locale=='japanese'){
						widthLen = 19 * widthLen;
					}
					else if(this.$i18n.locale=='english'){
						widthLen = 10 * widthLen;
					}else{
						widthLen = 9 * widthLen;
					}
					this.$refs.parseTips.style.width = widthLen +'px'
				},
				close(){
					this.parseTipsShow = false;
					this.$store.commit("setParseMagnet", null);
					this.$store.commit("setParseMagnetName", null);
					this.$store.commit("setCurrentParseMagnetId", -1);
				}
			}
		}
</script>

<style>
	
	#parseTips .el-loading-spinner i {
	    color: white !important;
	}
	
	#parseTips .el-loading-spinner .path {
		stroke: #FFFFFF !important;
	}
	
	#parseTips .el-loading-spinner {
		padding-top: 8px !important;
		/*no*/
	}
	
	#parseTips .el-loading-mask {
	    z-index: 1 !important;
	    background: #fff !important;
	}
	
	#parseTips .el-loading-spinner .circular{
			height: 0.25rem !important;
			width: 0.25rem !important;
	}
	
	.torrent-parse {
	    height: 50px;/*no*/
	    text-align: center;
	    top: 50px;/*no*/
	    left: 45%;
	    line-height: 30px;/*no*/
	    position: fixed;
	    margin: 0 auto;
	    background-color: #5166BD;
	    color: white;
	}
	
	.torrent-parse-loadding {
	    width: 10%;
	    margin: 25px 0px 25px 10px;/*no*/
	    float: left;
	}
	
	.torrent-parse-text {
	    text-align: center;
	    width: 65%;
		font-size: 13px;/*no*/
	    float: left;
		margin-top: 10px;/*no*/
	}
</style>



// WEBPACK FOOTER //
// src/components/popup/remote_task_popups/parse_tips.vue